import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InventoryItemHash } from '.';
import { uniqPrimativeMerge } from '../../utils/arrayUtils';
import { IInventoryRequest } from './inventoryInterfaces';

interface IInventoryState {
  hash: InventoryItemHash;
  loading: string[];
}

const initialState: IInventoryState = {
  hash: {},
  loading: []
};

// tslint:disable: no-empty
const inventorySlice = createSlice({
  initialState,
  name: 'inventory',
  reducers: {
    disableLoading: (state, action: PayloadAction<IInventoryRequest[]>) => {
      const idsArray = action.payload.map(y => `${y.itemId}_${y.inventDimId}`);
      state.loading = state.loading.filter(x => !idsArray.includes(x));
    },
    fetch: (state, action: PayloadAction<IInventoryRequest[]>) => {
      state.loading = uniqPrimativeMerge(
        state.loading,
        action.payload.map(x => `${x.itemId}_${x.inventDimId}`)
      );
    },
    set: (state, action: PayloadAction<InventoryItemHash>) => {
      state.hash = { ...state.hash, ...action.payload };
    }
  }
});

export const { actions: inventoryActionCreators, reducer: inventoryReducer } = inventorySlice;
